import React, {useEffect, useRef, useState} from "react";
import "@/views/Admin/Events/Event/Notifications/components/MultiSelect.scss";
import IconArrow from "@/assets/images/icons/16/arrow.svg";
import IconCheck from "@/assets/images/icons/16/icon_check.svg";
import IconError from "@/assets/images/icons/16/exclamation.svg";

// data -  [{ id: 1, label: "название 1" }, { id: 2, label: "название 2" }]
// value - [1,2,3]

const MultiSelect = ({label, data, value, error, onChange, labelEmpty, required}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // Закрываем дропдаун при клике вне
                setIsOpen(false);
                if (isOpen && required && value.length === 0) {
                    const firstItem = data[0]?.id;
                    if (firstItem) {
                        onChange([firstItem]);
                    }
                }
            }
        };

        // обработчик кликов
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Убираем обработчик при размонтировании компонента
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef, value, required, onChange, data]);


    const toggleSelect = (ticketId) => {
        if (value.includes(ticketId)) {
            if (required && value.length === 1) return;
            onChange(value.filter((id) => id !== ticketId));
        } else {
            onChange([...value, ticketId]);
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const getSelectedLabels = () => {
        return data
            .filter((ticket) => value.includes(ticket.id))
            .map((ticket) => ticket.label)
            .join(", ");
    };

    return (
        <div className={'parent-container'}>
            <div className="dropdown-container" ref={dropdownRef}>
                <label className="a-input__label_outside">{label}</label>
                <div onClick={toggleDropdown} className="dropdown-display">
                <span>
                    {value.length === 0
                        ? labelEmpty || `-`
                        : value.length === data.length
                            ? `Все`
                            : getSelectedLabels()}
                </span>
                    <span className={`${isOpen ? "rotate-180" : ""}`}>
                    <IconArrow/>
                </span>
                </div>

                {isOpen && (
                    <div className="dropdown-list">
                        {data.map((ticket) => (
                            <div
                                key={ticket.id}
                                onClick={() => toggleSelect(ticket.id)}
                                className={`dropdown-item ${value.includes(ticket.id) ? "selected" : ""}`}
                            >
                                <span>{ticket.label}</span>
                                {value.includes(ticket.id) && <IconCheck/>}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {error && <div className="ui-widget__message ui-widget__message-error">
                <IconError/>
                {error}
            </div>}
        </div>
    );
};

export default MultiSelect;
